// 导出 g-base 中的 interfaces
export * from '@antv/g-base/lib/interfaces';